export default {
    getSupportedCurrencies(){
        return [
            { text: "South African Rand (ZAR)", value: "ZAR" },
            {text: "South African Rand (R)", value: "R" },

            { text: "US Dollar (USD)", value: "USD" },
            { text: "Euro (EUR)", value: "EUR" },
            { text: "British Pound Sterling (GBP)", value: "GBP" },
            { text: "Indian Rupee (INR)", value: "INR" },

            { text: "Nigerian Naira (NGN)", value: "NGN" },
            { text: "Ghanaian Cedi (GHS)", value: "GHS" },
            { text: "Kenyan Shilling (KES)", value: "KES" },
            { text: "Zimbabwean ZiG (ZWG)", value: "ZWG" },
            { text: "Mozambican Metical (MZN)", value: "MZN" },

            { text: "Rwandan Franc (RWF)", value: "RWF" },
            { text: "Botswana Pula (BWP)", value: "BWP" },
            { text: "Mauritian Rupee (MUR)", value: "MUR" },
            { text: "Eswatini Lilangeni (SZL)", value: "SZL" },
            { text: "Lesotho Loti (LSL)", value: "LSL" },
            { text: "Seychellois Rupee (SCR)", value: "SCR" },
            { text: "Bahamian Dollar (BSD)", value: "BSD" },
            { text: "Barbadian Dollar (BBD)", value: "BBD" },
            { text: "Trinidad and Tobago Dollar (TTD)", value: "TTD" },
            { text: "Singapore Dollar (SGD)", value: "SGD" },
            { text: "Japanese Yen (JPY)", value: "JPY" },
            { text: "Australian Dollar (AUD)", value: "AUD" },
            { text: "Canadian Dollar (CAD)", value: "CAD" },
            { text: "Swiss Franc (CHF)", value: "CHF" },
            { text: "Chinese Yuan (CNY)", value: "CNY" },
            
            { text: "Hong Kong Dollar (HKD)", value: "HKD" },
            { text: "New Zealand Dollar (NZD)", value: "NZD" },
            { text: "Swedish Krona (SEK)", value: "SEK" },
            { text: "South Korean Won (KRW)", value: "KRW" },
            { text: "Norwegian Krone (NOK)", value: "NOK" },
            { text: "Mexican Peso (MXN)", value: "MXN" },
            { text: "Brazilian Real (BRL)", value: "BRL" },
            { text: "Saudi Riyal (SAR)", value: "SAR" },
            { text: "United Arab Emirates Dirham (AED)", value: "AED" },
            { text: "Israeli New Shekel (ILS)", value: "ILS" },
            { text: "Egyptian Pound (EGP)", value: "EGP" },
            { text: "Turkish Lira (TRY)", value: "TRY" },
            { text: "Indonesian Rupiah (IDR)", value: "IDR" },
            { text: "Malaysian Ringgit (MYR)", value: "MYR" },
            { text: "Philippine Peso (PHP)", value: "PHP" },
            { text: "Thai Baht (THB)", value: "THB" },
            { text: "Vietnamese Dong (VND)", value: "VND" },
            { text: "Pakistani Rupee (PKR)", value: "PKR" },
            { text: "Bangladeshi Taka (BDT)", value: "BDT" },
            { text: "Polish Zloty (PLN)", value: "PLN" },
            { text: "Danish Krone (DKK)", value: "DKK" },
            { text: "Czech Koruna (CZK)", value: "CZK" },
            { text: "Hungarian Forint (HUF)", value: "HUF" },
            { text: "Chilean Peso (CLP)", value: "CLP" },
            { text: "Colombian Peso (COP)", value: "COP" }
          ]
    }
}